<template>
    <div class="mb-3" :class="bsClass">
        <label :for="name" class="form-label" v-if="!labelHidden">
            {{ label }}
            <span class="text-danger" v-if="required"> *</span>
        </label>
        <multiselect
            v-model="clientSelected"
            :options="clients"
            :multiple="false"
            :close-on-select="true"
            :preserve-search="true"
            :placeholder="placeholder"
            label="name"
            :hide-selected="false"
            select-label=""
            selected-label=""
            deselect-label=""

            @search-change="searchClient"
        >
            <template v-slot:noResult>
                <span>Aucun résultats.</span>
            </template>
            <template v-slot:noOptions>
                <span>Écrivez pour rechercher un client...</span>
            </template>
            <!-- Croix pour tout désélectionner -->
            <template #clear>
                <span class="multiselect__clear" role="button" v-if="clientSelected && (clientSelected.id ?? clientSelected.code ?? clientSelected.name ?? clientSelected.label) != null" title="Effacer" aria-label="Effacer" @mousedown.prevent.stop="clientSelected = null"></span>
            </template>
        </multiselect>
        <span class="invalid-feedback text-danger" v-html="errorMessage()"></span>
        <span class="form-text text-muted" v-if="informationContent !== null">
            {{ informationContent }}
        </span>
    </div>
</template>

<script>
import _ from 'lodash';
export default {
    name: "FormSelectClient",
    props: {
        name : {
            type: String,
            required: true
        },
        label : {
            type: String,
            required: true
        },
        labelHidden : {
            type: Boolean,
            required: false,
            default: false
        },
        required : {
            type: Boolean,
            required: false,
            default: false
        },
        placeholder: {
            type: String,
            required: false,
            default: null
        },
        informationContent : {
            type: String,
            required: false,
            default: null
        },
        reference : {
            type: String,
            required: false,
            default: 'multiple-select'
        },
        clientPreSelected: {
            type: Object,
            required: false,
            default: null
        },
        errors: {
            required: true
        },
        bsClass: {
            type: String,
            required: false,
            default: "col-md-12"
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            clientSelected : [],
            clients: [],
            loading: false,
        }
    },
    mounted() {
    },
    methods: {
        searchClient: _.debounce(function(query) {
            if (query.length < 3) {
                return;
            }
            this.loading = true;
            axios.get('/api/search/clients', { params: { query: query } })
                .then(response => {
                    this.clients = response.data.data.map(client => ({
                        id: client.data.id,
                        name: `${client.data.first_name} ${client.data.last_name}`
                    }));
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        }, 250),
        clearAll () {
            this.clientSelected = []
        },
        clearErrors: function() {
            if (this.hasError) {
                this.errors[this.name] = null;
            }
        },
        errorClassObject: function() {
            return {
                "is-invalid": this.hasError
            }
        },
        errorMessage: function() {
            if (this.hasError) {
                return this.errors[this.name][0];
            }
        }
    },
    computed: {
        hasError() {
            return (
                this.errors &&
                this.errors[this.name] &&
                this.errors[this.name].length > 0
            );
        }
    },
    watch: {
        clientSelected: function(){
            if( this.clientSelected === null) {
                return this.$emit("update:field", null);
            } else {
                this.clearErrors(this.name);
                return this.$emit("update:field", this.clientSelected);
            }
        },
        clientPreSelected: {
            immediate: true,
            handler(newVal, oldVal) {
                //is not empty object or null
                if (this.clientPreSelected !== null && Object.keys(this.clientPreSelected).length !== 0 ) {
                    this.clientSelected = {
                        id: this.clientPreSelected.data.id,
                        name: this.clientPreSelected.data.first_name + ' ' + this.clientPreSelected.data.last_name
                    }
                    this.clients = [this.clientSelected];
                    this.$emit("update:field", this.clientSelected);
                }
            }
        }
    }
}
</script>

<style>

</style>
